(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hb-custom-product-card-styles"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__hbCardVariantsBound) return;
  window.__hbCardVariantsBound = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-hb-card-swatch], [data-hb-card-more]');
    if (!button) return;
    var card = button.closest('.hb-custom-product-card');
    if (!card) return;

    event.preventDefault();
    event.stopPropagation();

    if (button.hasAttribute('data-hb-card-more')) {
      var group = button.closest('[data-hb-card-variants]');
      if (!group) return;
      group.classList.add('is-expanded');
      button.setAttribute('aria-expanded', 'true');
      button.hidden = true;
      return;
    }

    var group = button.closest('[data-hb-card-variants]');
    if (group) {
      group.querySelectorAll('[data-hb-card-swatch]').forEach(function (swatch) {
        swatch.setAttribute('aria-pressed', swatch === button ? 'true' : 'false');
      });
    }

    var image = card.querySelector('.hb-custom-product-card__image:not(.hb-custom-product-card__placeholder)');
    if (image && button.dataset.hbVariantImage) {
      image.srcset = button.dataset.hbVariantSrcset || '';
      image.src = button.dataset.hbVariantImage;
      image.alt = button.dataset.hbVariantAlt || image.alt;
    }

    var price = card.querySelector('[data-hb-card-price]');
    if (price && button.dataset.hbVariantPrice) price.textContent = button.dataset.hbVariantPrice;

    var compare = card.querySelector('[data-hb-card-compare]');
    if (compare) {
      compare.textContent = button.dataset.hbVariantCompare || '';
      compare.hidden = button.dataset.hbVariantSale !== 'true';
    }

    var unavailable = button.dataset.hbVariantAvailable !== 'true';
    var sale = button.dataset.hbVariantSale === 'true';
    var soldBadge = card.querySelector('[data-hb-soldout-badge]');
    var saleBadge = card.querySelector('[data-hb-sale-badge]');
    if (soldBadge) soldBadge.hidden = !unavailable;
    if (saleBadge) saleBadge.hidden = unavailable || !sale;

    var link = card.querySelector('.hb-custom-product-card__link');
    if (link && button.dataset.hbVariantId) {
      var target = new URL(link.getAttribute('href'), document.baseURI);
      target.searchParams.set('variant', button.dataset.hbVariantId);
      link.setAttribute('href', target.pathname + target.search + target.hash);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
